import React from "react"

import PulsingDots from "./common/PulsingDots"

type LoadingScreenProps = {
  title?: string
  subtitle?: string
  color?: string
}

const LoadingScreen = ({ title, subtitle, color = "nelo-blue" }: LoadingScreenProps) => {
  return (
    <div className="flex h-screen w-full flex-col px-4 pb-8 pt-32 lg:px-8">
      {title && <h1 className="mb-4 text-4xl font-bold text-nelo-blue">{title}</h1>}
      {subtitle && <p className="mb-8 text-ui-fg-base">{subtitle}</p>}
      <PulsingDots color={color} />
    </div>
  )
}

export default LoadingScreen
